import { createConfig } from "wagmi"
import { http } from "viem";
import { connectorsForWallets } from "@rainbow-me/rainbowkit";
import {
  metaMaskWallet,
  rabbyWallet,
} from '@rainbow-me/rainbowkit/wallets';
import { abstractWallet } from "@abstract-foundation/agw-react/connectors";
import { ABS_CHAIN, IS_TESTNET, RPC_URL, WWW } from "./constants";
import { abstract, abstractTestnet } from "viem/chains";

const connectors = connectorsForWallets(
  [
    {
      groupName: "Recommended",
      wallets: [abstractWallet, rabbyWallet, metaMaskWallet],
    },
  ],
  {
    projectId: "4e35fd02b235ab407a610313ca11dff7",
    appName: "BLINKO",
    appDescription: "Addictingly good physics-based Plinko where you bet money, earn honey, and chase B-O-N-U-S. Provably fair on-chain with deterministic physics. Play on Abstract.",
    appIcon: "https://www.blinko.gg/favicon.png",
    appUrl: WWW,
  }
);

export const wagmiConfig = createConfig({
  chains: [ABS_CHAIN],
  connectors,
  transports: {
    [abstract.id]: http(RPC_URL),
    [abstractTestnet.id]: http(RPC_URL),
  },
})
  